export default "__VITE_ASSET__P1kIw5kO__"